/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterData
 */
export interface FilterData {
    /**
     * 
     * @type {Date}
     * @memberof FilterData
     */
    dateFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FilterData
     */
    dateTo?: Date;
    /**
     * 
     * @type {string}
     * @memberof FilterData
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterData
     */
    healthcareFacilityId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FilterData
     */
    withExamined?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterData
     */
    withLinkedPayments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterData
     */
    onlyUnpaid?: boolean;
}

/**
 * Check if a given object implements the FilterData interface.
 */
export function instanceOfFilterData(value: object): value is FilterData {
    return true;
}

export function FilterDataFromJSON(json: any): FilterData {
    return FilterDataFromJSONTyped(json, false);
}

export function FilterDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterData {
    if (json == null) {
        return json;
    }
    return {
        
        'dateFrom': json['dateFrom'] == null ? undefined : (new Date(json['dateFrom'])),
        'dateTo': json['dateTo'] == null ? undefined : (new Date(json['dateTo'])),
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'healthcareFacilityId': json['healthcareFacilityId'] == null ? undefined : json['healthcareFacilityId'],
        'withExamined': json['withExamined'] == null ? undefined : json['withExamined'],
        'withLinkedPayments': json['withLinkedPayments'] == null ? undefined : json['withLinkedPayments'],
        'onlyUnpaid': json['onlyUnpaid'] == null ? undefined : json['onlyUnpaid'],
    };
}

export function FilterDataToJSON(value?: FilterData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dateFrom': value['dateFrom'] == null ? undefined : ((value['dateFrom']).toISOString()),
        'dateTo': value['dateTo'] == null ? undefined : ((value['dateTo']).toISOString()),
        'companyId': value['companyId'],
        'healthcareFacilityId': value['healthcareFacilityId'],
        'withExamined': value['withExamined'],
        'withLinkedPayments': value['withLinkedPayments'],
        'onlyUnpaid': value['onlyUnpaid'],
    };
}

